import React, { useCallback, useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import "./DirectSearch.css";
import { stateCities } from "../constants/stateCities";
import { specialities } from "../constants/specialities";
import { dbes } from "../constants/dbes";
import SearchableSelect from "./SearchableSelect"; // Add this import

const DirectSearchPage = () => {
  const { accounts } = useMsal();
  const [userEmail, setUserEmail] = useState('');
  
  useEffect(() => {
    if (accounts.length > 0) {
      const potentialEmail =
        accounts[0].idTokenClaims?.email ||
        accounts[0].idTokenClaims?.preferred_username ||
        accounts[0].username || '';
      
      console.log("Extracted email:", potentialEmail);
      setUserEmail(potentialEmail);
    }
  }, [accounts]);

  const [searchPerformed, setSearchPerformed] = useState(false);
  const [formData, setFormData] = useState({
    npi: "",
    firstName: "",
    lastName: "",
    address: "",
    state: "",
    city: "",
    mailingCity: "",
    mailingState: "",
    mailingAddress: "",
    licenseState: "",
    licenseNumber: "",
    specialty: "",
    mailing_postal_code: "",
    practice_postal_code: "",
    taxonomy_code: "",
    provider_Credential_Text: "",
    provider_Name_Prefix_Text: "",
    select_db: "",
  });

  const [isSearchCompleted, setIsSearchCompleted] = useState(false);
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [exactMatches, setExactMatches] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popupRowIndex, setPopupRowIndex] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalExactMatches, setTotalExactMatches] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [directSearchError, setDirectSearchError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [copyMessage, setCopyMessage] = useState("");
  const [viewLoadingIndex, setViewLoadingIndex] = useState(null);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "npi") {
  //     const numericValue = value.replace(/\D/g, "").slice(0, 10);
  //     setFormData((prev) => ({ ...prev, [name]: numericValue }));
  //     if (numericValue && numericValue.length !== 10) {
  //       setDirectSearchError("NPI must be exactly 10 digits");
  //     } else {
  //       setDirectSearchError("");
  //     }
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "npi") {
      // Allow any alphanumeric input (letters + numbers)
      const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, "");
      setFormData((prev) => ({ ...prev, [name]: alphanumericValue }));
      setDirectSearchError(""); // clear previous error if any
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleMailingStateChange = (e) => {
    const mailingState = e.target.value;
    setFormData({ ...formData, mailingState });
    setSearchPerformed(false);
    const mailingCities = stateCities[mailingState] || [];
    setCities(mailingCities);
  };

  const handleStateChange = (e) => {
    const state = e.target.value;
    setFormData({ ...formData, state });
    setCities(stateCities[state] || []);
    setSearchPerformed(false);
  };
  // const loadingRef = React.useRef(null);
  const resultsRef = React.useRef(null);

  const handleSearch = useCallback(
    async (page = 1) => {
      // Remove the old NPI 10-digit validation
      if (formData.npi && formData.npi.trim() === "") {
        setDirectSearchError("Codice Fiscale cannot be empty.");
        return;
      }
  
      const isAllFieldsEmpty = Object.values(formData).every(
        (value) => !value || value.trim() === ""
      );
      if (isAllFieldsEmpty) {
        setDirectSearchError(
          "Please fill at least one field to perform the search."
        );
        return;
      }
  
      const term = getSearchTerm();
      setDirectSearchError("");
      setSearchPerformed(false);
      setIsSearching(true);
      setIsSearchCompleted(false);
      setExactMatches([]);
      setResults([]);
      setCurrentPage(1);
      setLoading(true);
  
      const filteredParams = Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => value.trim() !== "")
      );
  
      const pageNumber = isNaN(Number(page)) ? 1 : Number(page);
      const limitNumber = Number(limit);
  
      const params = {
        ...filteredParams,
        page: pageNumber,
        limit: limitNumber,
      };
  
      try {
        setPopupRowIndex(null);
        setSelectedRecord(null);
  
        const directEndpoint = `${process.env.REACT_APP_BACKEND_URL}/search/direct`;
        const directResponse = await axios.get(directEndpoint, {
          params: {
            ...params,
            userEmail,
            select_db: formData.select_db || "Francedb only",
          },
        });
  
        if (directResponse?.data?.results?.length > 0) {
          setExactMatches(directResponse.data.results || []);
          setTotalExactMatches(directResponse.data.total || 0);
          console.log("directEndpoint", directEndpoint);
          console.log("directResponse", directResponse);
  
          setTimeout(() => {
            if (resultsRef.current) {
              resultsRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        }
        setResults([]);
      } catch (err) {
        console.error("Error during search:", err);
        setTotalExactMatches(0);
      } finally {
        setIsSearching(false);
        setIsSearchCompleted(true);
        setSearchPerformed(true);
        setLoading(false);
      }
    },
    [formData, limit]
  );
  
  const handlePageChange = async (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(totalExactMatches / limit)) {
      setCurrentPage(newPage);
      setIsSearching(true);
      try {
        const params = {
          ...Object.fromEntries(
            Object.entries(formData).filter(([_, value]) => value.trim() !== "")
          ),
          page: newPage,
          limit: limit,
          userEmail ,
          select_db: formData.select_db || "Francedb only" 

        };
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/search/direct`,
          { params }
        );
        if (response?.data?.results?.length > 0) {
          setExactMatches(response.data.results || []);
          setTotalExactMatches(response.data.total || 0);
        } else {
          // Handle case when pagination returns no results
          setExactMatches([]);
          setTotalExactMatches(0);
        }
      } catch (err) {
        console.error("Error fetching next page:", err);
        // Clear results on error
        setExactMatches([]);
        setTotalExactMatches(0);
      } finally {
        setIsSearching(false);
      }
    }
  };
  const handleCopy = (item) => {
    const copyContent = [
      item.NPI || "",
      item.HCP_first_name || "",
      item.HCP_last_name || "",
      item.sp_2 || "",
      item.practice_st || ""
    ].join("|");

    navigator.clipboard
      .writeText(copyContent)
      .then(() => {
        setCopyMessage("Copied to clipboard!");
        setTimeout(() => setCopyMessage(""), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
        setCopyMessage("Failed to copy!");
        setTimeout(() => setCopyMessage(""), 2000);
      });
  };

  const handleLicenseStateChange = (e) => {
    const licenseState = e.target.value;
    setFormData({ ...formData, licenseState });
    setSearchPerformed(false);
  };



  const handleView = (record, index) => {
    if (popupRowIndex === index) {
      // Toggle off if clicking the same row
      setPopupRowIndex(null);
      setSelectedRecord(null);
    } else {
      // Use the existing record data instead of making an API call
      setPopupRowIndex(index);
      setSelectedRecord(record);
    }
  };

  const getSearchTerm = () => {
    const {
      firstName,
      lastName,
      npi,
      specialty,
      city,
      state,
      address,
      mailingAddress,
      mailingCity,
      mailingState,
      licenseNumber,
      licenseState,
      select_db,
    } = formData;
    let term = "";

    if (firstName) {
      term += `First Name: ${firstName}`;
    }
    if (lastName) {
      term += term ? `, Last Name: ${lastName}` : `Last Name: ${lastName}`;
    }
    if (npi) {
      term += term ? `, NPI: ${npi}` : `NPI: ${npi}`;
    }
    if (specialty) {
      term += term ? `, Specialty: ${specialty}` : `Specialty: ${specialty}`;
    }
    if (select_db) {
      term += term ? `, select_db: ${select_db}` : `select_db: ${select_db}`;
    }
    if (city || state) {
      term += term
        ? `, Location: ${city}, ${state}`
        : `Location: ${city}, ${state}`;
    }
    if (address) {
      term += term ? `, Address: ${address}` : `Address: ${address}`;
    }
    if (mailingAddress) {
      term += term
        ? `, Mailing Address: ${mailingAddress}`
        : `Mailing Address: ${mailingAddress}`;
    }
    if (mailingCity || mailingState) {
      term += term
        ? `, Mailing Location: ${mailingCity}, ${mailingState}`
        : `Mailing Location: ${mailingCity}, ${mailingState}`;
    }
    if (licenseNumber) {
      term += term
        ? `, License Number: ${licenseNumber}`
        : `License Number: ${licenseNumber}`;
    }
    if (licenseState) {
      term += term
        ? `, License State: ${licenseState}`
        : `License State: ${licenseState}`;
    }

    return term || "your search";
  };

  const clearForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      address: "",
      npi: "",
      specialty: "",
      state: "",
      city: "",
      licenseState: "",
      licenseNumber: "",
      mailingState: "",
      mailingCity: "",
      mailingAddress: "",
      select_db: "" ,
    });
    setResults([]);
    setExactMatches([]);
    setSearchPerformed(false);
  };

  return (
    <div className="direct-search-container">
     <header className="header">
  <h1>HCP Search</h1>
  <img src="https://flagcdn.com/fr.svg" alt="France" className="flag" />
</header>


      {searchPerformed && (
        <p className="search-message">Search has been performed.</p>
      )}

     

    <div className="search-form">
        <div className="form-row">
          <div className="form-field">
            <label>First Name</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="Enter First Name"
              disabled={isSearching}
            />
          </div>
          <div className="form-field">
            <label>Last Name</label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Enter Last Name"
              disabled={isSearching}
            />
          </div>
          <div className="form-field">
  <label>RPPS ID</label>
  <input
    name="npi"
    value={formData.npi}
    onChange={handleInputChange}
    placeholder="Enter RPPS"
    disabled={isSearching}
    inputMode="text"
    pattern="[A-Za-z0-9]+"
    title="Codice Fiscale can include letters and numbers"
  />
  {directSearchError && formData.npi && (
    <span className="field-error">{directSearchError}</span>
  )}
</div>

        </div>

        <div className="form-row">
          {/* <div className="form-field">
            <label>State</label>
            <SearchableSelect
              name="state"
              value={formData.state}
              onChange={handleStateChange}
              options={Object.keys(stateCities)}
              placeholder="Select State"
              disabled={isSearching}
            />
          </div> */}
          <div className="form-field">
            <label>Postal Code</label>
            <SearchableSelect
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              options={cities}
              placeholder="Select Postal Code"
              disabled={isSearching}
            />
          </div>
          <div className="form-field">
            <label>Address</label>
            <input
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Enter Address"
              disabled={isSearching}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-field">
            <label>Professional Designation</label>
            <SearchableSelect
              name="specialty"
              value={formData.specialty}
              onChange={handleInputChange}
              options={specialities}
              placeholder="Select Professional Designation"
              disabled={isSearching}
            />
          </div>
       
       
       
        </div>

       
        </div>
      <div className="actions">
          <button onClick={handleSearch} disabled={isSearching}>
            <img src="/images/search.png" alt="Search" /> Search
          </button>
          <button onClick={clearForm} disabled={isSearching}>
            <img src="/images/clear-format.png" alt="Clear" /> Clear
          </button>
         
      
       
 </div>
 {directSearchError && (
        <div className="error-message">
          <p>{directSearchError}</p>
        </div>
      )}
 <div>
 {loading && <div className="revolving-loader"></div>}
   {/* ✅ Show "No Results Found" */}
   {!loading && exactMatches.length === 0 && isSearchCompleted && (
    <div className="no-results">
      <p>No results found.</p>
    </div>
  )}
        </div>
      {exactMatches.length > 0 && (
        <div  ref={resultsRef} className="suggestedmatches">
          <h3>Search Results</h3>
          {copyMessage && <div className="copy-message">{copyMessage}</div>}
          <>
          <div className="search-results">
            <table className="results-table">
              <thead>
               <tr>
                                <th>RPPS ID</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Professional Designation</th>
                                {/* <th>State</th> */}
                                <th>Postal Code</th>
                                <th>Address</th>
                                <th>Action</th>
                            </tr>
              </thead>
              <tbody>
                {exactMatches.map((item, index) => (
                  <React.Fragment key={item.NPI}>
                    <tr>
                    <td>{item.NPI}</td>
                                        <td>{item.HCP_first_name}</td>
                                        <td>{item.HCP_last_name}</td>
                                        <td>{item.sp_2}</td>
                                        {/* <td>{item.practice_st}</td> */}
                                        <td>{item.practice_city}</td>
                                        <td>{item.practice_address}</td>
                      <td>
                      <button
  onClick={() => handleView(item, index)}
  disabled={isSearching || viewLoadingIndex === index}
>
  {viewLoadingIndex === index ? 'Loading...' : 'View'}
</button>

                        <button
                          style={{ marginLeft: "5px" }}
                          onClick={() => handleCopy(item)}
                          disabled={isSearching}
                        >
                          Copy Details
                        </button>
                      </td>
                    </tr>
                    {popupRowIndex === index && selectedRecord && (
  <tr className="details-row">
    <td colSpan={8}>
      <div className="details-content">
        <h4>Detailed Information</h4>
        <div className="details-grid">
          <div>
            <p><strong>First Name:</strong> {selectedRecord.HCP_first_name || "N/A"}</p>
            <p><strong>Last Name:</strong> {selectedRecord.HCP_last_name || "N/A"}</p>
            <p><strong>Professional Designation:</strong> {selectedRecord.sp_2 || "N/A"}</p>
            <p><strong>Postal Code:</strong> {selectedRecord.practice_city || "N/A"}</p>
            <p><strong>Address:</strong> {selectedRecord.practice_address || "N/A"}</p>
            {/* <p><strong>Provider License State:</strong> {selectedRecord.Provider_License_Number_State_Code || "N/A"}</p> */}
          </div>
        </div>
      </div>
    </td>
  </tr>
)}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <p>{totalExactMatches} records are found.</p>
            <div className="pagination-controls">
              <button
                type="button"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1 || isSearching}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {Math.ceil(totalExactMatches / limit)}
              </span>
              <button
                type="button"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={
                  currentPage === Math.ceil(totalExactMatches / limit) ||
                  isSearching
                }
              >
                Next
              </button>
            </div>
            </div>

          </>
        </div>
      )}
    </div>
  );
};

export default DirectSearchPage;